const RecipeBlog = {
    pathname: null,
    url: `${window.location.origin}/blogs/recipes`,
    
    init() {
        this.pathname = window.location.pathname;
        if (!this.isRecipePage()) return;
        this.run();
    },
    
    checkedTags() {
        const tags = Array.from(document.querySelectorAll('.recipe-filter:checked'))
            .map(el => el.value);
        return this.compact(tags);
    },
    
    clickTagHandler(event) {
        const joinedTags = this.joinedTags();
        let url = this.url;
        if (joinedTags) {
            url = `${this.url}/tagged/${joinedTags}`;
        }
        
        fetch(url)
            .then(response => response.text())
            .then(html => {
                document.getElementById('product-grid-wrapper').style.opacity = 0.2;
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const content = doc.getElementById('product-grid-wrapper');
                document.getElementById('product-grid-wrapper').replaceWith(content);
                history.pushState({}, '', url);
            })
            .catch(() => {
                document.getElementById('product-grid-wrapper').style.opacity = 1;
            });
    },
    
    compact(array) {
        return array.filter(Boolean);
    },
    
    isRecipePage() {
        return this.pathname.startsWith('/blogs/recipes');
    },
    
    joinedTags() {
        return this.checkedTags().join('+');
    },
    
    paths() {
        return this.compact(this.pathname.split('/'));
    },
    
    run() {
        this.setTags();
        this.setTagHandlers();
    },
    
    setTags() {
        const tags = this.tags();
        if (!tags.length) return;
        tags.forEach(tag => {
            const checkbox = document.querySelector(`.recipe-filter[value="${tag}"]`);
            if (checkbox) checkbox.checked = true;
        });
    },
    
    setTagHandlers() {
        document.querySelectorAll('.recipe-filter').forEach(el => {
            el.addEventListener('click', this.clickTagHandler.bind(this));
        });
    },
    
    tags() {
        const paths = this.paths();
        return paths.length ? paths.pop().split('+') : [];
    }
};

document.addEventListener('DOMContentLoaded', () => RecipeBlog.init());